import React from 'react'

const Toolbar: React.FC = () => {
  return (
    <div className="h-16 bg-gray-800 text-white flex items-center px-4 shadow-lg">
      <a
        href="https://omegasunproject.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3 hover:opacity-80 transition-opacity"
      >
        <div className="h-12 w-12 rounded-full border-2 border-black flex items-center justify-center overflow-hidden bg-white m-2">
          <img
            src="/omegasun-logo.png"
            alt="OmegaSun Project Logo"
            className="h-full w-full object-cover"
          />
        </div>
        <h1 className="text-xl font-bold">Omega Sun Project</h1>
      </a>
      {/* Placeholder for future controls */}
    </div>
  )
}

export default Toolbar
